module.exports = __webpack_public_path__ + "static/media/empty-profile-image.759c96e5.svg";